var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b704e501-34d9-46b3-9fc2-db188c6e7dd7",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a0de9ee3-752c-48ad-82c8-752a900a3404",
    "data-name": "Path 39",
    d: "M6.789,13.213v2.281l.874-.762,1.794-1.526h.527c1.412.013,2.824.008,4.237.005a2.121,2.121,0,0,0,2.2-2.308q.014-2.093,0-4.183a2.087,2.087,0,0,0-1.973-2.2c-.028,0-.055,0-.083,0q-4.353-.028-8.707,0A2.057,2.057,0,0,0,3.6,6.579c0,.028,0,.056,0,.083q-.043,2.213,0,4.426a2.083,2.083,0,0,0,2.041,2.124H6.792",
    style: {
      fill: "#0cba00"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxLanguage);
export default __webpack_public_path__ + "static/media/bxLanguage.2bf8d42a2ca3dae18043d3fb0f8cbac2.svg";
export { ForwardRef as ReactComponent };